import * as React from 'react';
import { Box, Button, CircularProgress, Divider, Grid, TextField, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';

import { useCreateZoneCategoryServiceItemMutation } from 'store/apis';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { CategoryServiceItemList } from 'components';
import { useZoneCategoryServiceItems } from 'store/apis/zone-categories/zone-categories.hook';

interface ZoneCategoryServiceItemsFormProps {
  categoryId: number;
}

export const ZoneCategoryServiceItemsForm = ({ categoryId }: ZoneCategoryServiceItemsFormProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const [name, setName] = React.useState('');
  const [error, setError] = React.useState('');
  const [createItem, { isLoading }] = useCreateZoneCategoryServiceItemMutation();
  const { data: serviceItems, isLoading: isFetching } = useZoneCategoryServiceItems({ categoryId });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('Service item name is required.');
      return;
    }
    setError('');
    createItem({ orgSlug, categoryId, name: name.trim() }).then(() => setName(''));
  };

  return (
    <Box>
      <Divider sx={{ my: 3 }} />
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
        Default Service Items
      </Typography>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={10}>
            <TextField
              label="Service item"
              placeholder="Input service name..."
              variant="outlined"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              error={!!error}
              helperText={error || undefined}
            />
          </Grid>
          <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Button
              type="submit"
              startIcon={isLoading ? <CircularProgress color="inherit" size={16} sx={{ mr: 0.5 }} /> : <Add />}
              sx={{ paddingX: 2 }}
              disabled={isLoading}
            >
              Add
            </Button>
          </Grid>
        </Grid>
      </form>

      {isFetching ? null : <CategoryServiceItemList serviceItems={serviceItems} />}
    </Box>
  );
};
